import { render, staticRenderFns } from "./FormRadioBox.vue?vue&type=template&id=77a0c8b8&scoped=true"
import script from "./FormRadioBox.vue?vue&type=script&lang=js"
export * from "./FormRadioBox.vue?vue&type=script&lang=js"
import style0 from "./FormRadioBox.vue?vue&type=style&index=0&id=77a0c8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0c8b8",
  null
  
)

export default component.exports